// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { PERSONAL_DATA_URL, PERSONAL_DATA_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI 
const { AdditionalQuestionindex } = lazily(() => import('pages/back-office/personal-data/additional-question'))

const additionalQuestionRoutes: IRoute[] = [{
    path: PERSONAL_DATA_URL.ADDITIONAL_QUESTION,
    component: AdditionalQuestionindex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: PERSONAL_DATA_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.additionalQuestion',
        accessCodes: [225],
      },
    },
}]

export { additionalQuestionRoutes }